var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.696,
    height: 71.696,
    viewBox: "0 0 71.696 71.696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10147",
    "data-name": "Grupo 10147",
    transform: "translate(-3032.5 -2915.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6856",
    "data-name": "Trazado 6856",
    d: "M570.99,44.87a1.12,1.12,0,1,1-1.12-1.12,1.12,1.12,0,0,1,1.12,1.12",
    transform: "translate(2527.603 2877.356)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6857",
    "data-name": "Trazado 6857",
    d: "M535.99,44.87a1.12,1.12,0,1,1-1.12-1.12,1.12,1.12,0,0,1,1.12,1.12",
    transform: "translate(2558.122 2877.356)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6858",
    "data-name": "Trazado 6858",
    d: "M500.99,44.87a1.12,1.12,0,1,1-1.12-1.12,1.12,1.12,0,0,1,1.12,1.12",
    transform: "translate(2588.641 2877.356)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6859",
    "data-name": "Trazado 6859",
    d: "M137.78,0H73.926a3.92,3.92,0,0,0-3.921,3.921V67.775A3.92,3.92,0,0,0,73.926,71.7H137.78a3.92,3.92,0,0,0,3.921-3.921V3.921A3.92,3.92,0,0,0,137.78,0ZM73.926,2.24H137.78a1.68,1.68,0,0,1,1.68,1.68V11.2H72.246V3.921A1.68,1.68,0,0,1,73.926,2.24ZM137.78,69.455H73.926a1.68,1.68,0,0,1-1.68-1.68V13.442H139.46V67.775A1.68,1.68,0,0,1,137.78,69.455Z",
    transform: "translate(2962.495 2915.504)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6860",
    "data-name": "Trazado 6860",
    d: "M189.572,204.311a1.121,1.121,0,0,0-.56-1.468l-.868-.359a2.928,2.928,0,0,0-.051-.56,3.03,3.03,0,1,0-2.442,3.5,2.984,2.984,0,0,0,1.619-.868l.868.364a1.168,1.168,0,0,0,.431.084,1.121,1.121,0,0,0,1-.689Zm-4.358-1.092a.808.808,0,0,1-.588-.129.8.8,0,0,1-.325-.5.807.807,0,0,1,.129-.56.8.8,0,0,1,.5-.325h.14a.775.775,0,0,1,.448.14.762.762,0,0,1-.291,1.378Z",
    transform: "translate(2864.771 2741.626)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6861",
    "data-name": "Trazado 6861",
    d: "M140.675,143.16a4.4,4.4,0,1,1-.005,0Zm-12.608,14.193.6-.61a1.12,1.12,0,1,0-1.568-1.585l-.616.616a8.339,8.339,0,0,1-1.68-3.977h.879a1.12,1.12,0,1,0,0-2.24h-.851a8.292,8.292,0,0,1,1.647-3.966l.6.605a1.121,1.121,0,1,0,1.585-1.585L128.05,144h0a8.271,8.271,0,0,1,3.977-1.641v.863a1.12,1.12,0,0,0,2.24,0v-.863a8.358,8.358,0,0,1,3.96,1.68l-.6.571a1.125,1.125,0,1,0,1.6,1.585l.6-.6a8.344,8.344,0,0,1,1.641,3.96h-.846a1.12,1.12,0,1,0,0,2.24h.846a7.868,7.868,0,0,1-.207,1.031l-.8-.331h0a1.12,1.12,0,0,0-.857,2.067l.8.331a7.619,7.619,0,0,1-.56.868l-.627-.605a1.121,1.121,0,0,0-1.585,1.585l.605.605h0a8.341,8.341,0,0,1-10.166,0Z",
    transform: "translate(2916.717 2793.394)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6862",
    "data-name": "Trazado 6862",
    d: "M141.383,345.225a3.787,3.787,0,1,0,.006,0Zm-1.092,2.33a8.4,8.4,0,0,1,1.16,3.271h-5.17Zm-7.153,12.793a8.4,8.4,0,1,1,5.741-14.524l-6.458,5.254a1.12,1.12,0,0,0,.717,1.988h8.307a8.4,8.4,0,0,1-8.307,7.282Z",
    transform: "translate(2916.724 2617.89)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6863",
    "data-name": "Trazado 6863",
    d: "M355.117,140H324.87a1.12,1.12,0,0,0-1.12,1.12V159.6a1.12,1.12,0,0,0,1.12,1.12h30.247a1.12,1.12,0,0,0,1.12-1.12V141.12a1.12,1.12,0,0,0-1.12-1.12ZM354,142.24v1.68l-5.344,3.8-5.215-1.529a1.12,1.12,0,0,0-1.12.314l-5.187,5.6-5.54-2.487a1.12,1.12,0,0,0-1.154.146l-4.447,3.512V142.24Zm-28.006,16.244v-2.358l5.3-4.184,5.64,2.526h0a1.12,1.12,0,0,0,1.277-.264l5.265-5.652,5.075,1.484a1.12,1.12,0,0,0,.964-.162l4.481-3.193v11.8Z",
    transform: "translate(2741.236 2793.428)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6864",
    "data-name": "Trazado 6864",
    d: "M356.13,334.332a4.481,4.481,0,0,0-8.637-1.68l-3.187-.734a4.481,4.481,0,0,0-8.9.734,4.673,4.673,0,0,0,.129,1.053l-4.134,3.182h0a4.481,4.481,0,1,0-4.4,7.383V348.9h-2.241a1.12,1.12,0,0,0,0,2.24H355.01a1.12,1.12,0,0,0,0-2.24h-2.24V338.667a4.482,4.482,0,0,0,3.361-4.335Zm-4.481-2.24a2.24,2.24,0,1,1-1.584.656A2.241,2.241,0,0,1,351.649,332.091Zm-11.763-1.68a2.24,2.24,0,1,1-1.584.656A2.241,2.241,0,0,1,339.887,330.411Zm-14,9.522a2.24,2.24,0,1,1,.656,1.584A2.241,2.241,0,0,1,325.883,339.933Zm3.361,4.335a4.482,4.482,0,0,0,3.361-4.335,4.673,4.673,0,0,0-.129-1.053l4.134-3.182h0a4.48,4.48,0,0,0,2.157,1.288v11.908h-9.522Zm11.763,4.627V336.987a4.481,4.481,0,0,0,3.086-2.8l3.114.706a4.482,4.482,0,0,0,3.322,3.775V348.9Z",
    transform: "translate(2741.343 2629.343)",
    fill: "#b1ca56"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.078e0d7a7df2eff65266e8b1bb1eb3b4.svg";
export { ForwardRef as ReactComponent };